angular.module('dyb.util', [
    "ngCookies",

    "dyb.util.dates",
    "dyb.util.dolRegions",
    "dyb.util.efls",
    "dyb.util.input",
    "dyb.util.forms",
    "dyb.util.models",
    "dyb.util.constants",
    "dyb.util.widgets",
    "dyb.util.filters",
    "dyb.util.services",
    'dybCharts',
    'dybTags',
]);
